import { createSlice } from '@reduxjs/toolkit'
import i18next from 'i18next'

export const initialState = {
  language: "de",
  showLoginModal: false,
  isAuthed: false,
  token: null,
  bimCollabToken: null,
  loading: true,
  userInfo: {},
  userConfig: {},
  viewerConfig: {},
  clearanceInspectorConfig: {},
  loadingProjects: true,
  userProjects: [],
  error: null,
  notification: null,
  centeredNotification: null,
  success: false,
  activeProjectId: null,
  activeProject: null,
  activeCustomer: null,
  epsgs: {},
  roles: {},
  permissions:{},
  userPermissions: [],
  processTypes: {},
  sensorTypes: {},
  processStatuses: {},
  customers: {},
  activeCustomerId: null,
  generatingShareLink: false,
  shareableLinkId: null,
  isTokenRefreshing:false,
  changeLogs:[],
  changeLogConfigs:{isUnread:false, forceOpen:false},
  lastURL:null,
  tracklayerTypes:[],
  externalGeoServices: [],
  projectExternalGeoServices: [],
  externalGeoServiceTypes: [],
  ownRoles: [],
  showNews: true,
}

const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    logout: (state) => {

      state.loading = false
      state.userInfo = null
      state.userToken = null
      state.error = null
      state.isAuthed = false
      state.clearanceInspectorConfig = {}

    },
    setUserInfo: (state, { payload }) => {
      state.userInfo = payload
      state.isAuthed = true
      state.error = null
    },

    setUserToken: (state, { payload }) => {
      state.token = payload

    },

    setBimCollabToken: (state, { payload }) => {
      state.bimCollabToken = payload
    },

    setUserConfigs: (state, { payload }) => {
      state.userConfig = payload || {}
    },
    setErrors: (state, { payload }) => {
      state.error = payload
    },

    initviewerConfig: (state, { payload }) => {
      state.viewerConfig = payload || {}
    },
    initClearanceInspectorConfig: (state, { payload }) => {
      state.clearanceInspectorConfig = payload || {}
    },
    setClearanceInspectorConfig: (state, { payload }) => {
      const { projectId, runId, swlId } = payload
      state.clearanceInspectorConfig[projectId] = { runId, swlId }
    },
    setviewerConfig: (state, { payload }) => {
      let viewerConfig = state.viewerConfig
      viewerConfig[payload.activeProjectId] = payload.viewerConfig
      state.viewerConfig = viewerConfig
    },
    setActiveProject: (state, { payload }) => {
      state.activeProjectId = payload
      const selectedProject = state.userProjects.find(row => row.projectId == payload)
      state.activeProject = {...selectedProject}
    },
    setActiveCustomer: (state, { payload }) => {
      state.activeCustomerId = payload
      const selectedCustomer = state.customers[payload]
      state.activeCustomer = selectedCustomer
    },

    setActiveCustomerRoles: (state, { payload }) => {
      state.ownRoles = payload.ownRoles

      const userRoles= payload.ownRoles.length ? payload.ownRoles.map(row=>row.roleName) :state.userInfo.userRoles
      state.userPermissions= payload.ownPermissions.length ? payload.ownPermissions.map(row=>row.permissionName) :[]
      let userInfoCopied ={...state.userInfo}
      userInfoCopied.userRoles = userRoles
      userInfoCopied.isAdmin = userRoles.includes("Superadministrator") || userRoles.includes("Administrator")
      userInfoCopied.isSuperAdmin= userRoles.includes("Superadministrator")
      state.loading = false
      state.userInfo = userInfoCopied

      console.log("activeCustomer", state.activeCustomer)
    },

    resetActiveProject: (state, { payload }) => {
      state.activeProjectId = null;
      state.activeProject = null;
    },
    setLoadingProjects: (state, { payload }) => {
      state.loadingProjects = true
    },
    setProjects: (state, { payload }) => {
      const sortedProjects = payload.sort((a, b) => a.projectName.localeCompare(b.projectName))
      state.userProjects = sortedProjects
      if (state.activeProjectId) {
        const selectedProject = sortedProjects.find(row => row.projectId == state.activeProjectId)
        state.activeProject = selectedProject
      }
      state.loadingProjects = false
    },
    setEpsgs: (state, { payload }) => {
      state.epsgs = payload
    },
    setExternalGeoServices: (state, { payload }) => {
      state.externalGeoServices = payload
    },
    setProjectExternalGeoServices: (state, { payload }) => {
      state.projectExternalGeoServices = payload
    },
    setExternalGeoServiceTypes: (state, { payload }) => {
      state.externalGeoServiceTypes = payload
    },
    setTrackLayerTypes: (state, { payload }) => {
      state.tracklayerTypes = payload
    },
    setLoading: (state, { payload }) => {
      console.log("loading", payload)
      state.loading = payload
    },
    setProcessTypes: (state, { payload }) => {
      state.processTypes = payload
    },
    setSensorTypes: (state, { payload }) => {
      state.sensorTypes = payload
    },
    setProcessStatuses: (state, { payload }) => {
      state.processStatuses = payload
    },
    setCusomers: (state, { payload }) => {
      state.customers = payload
    },
    setRoles: (state, { payload }) => {
      state.roles = payload
    },
    setPermissions: (state, { payload }) => {
      state.permissions = payload
    },
    setLanguage: (state, { payload }) => {
      const normalizedLanguage = typeof payload === "string" ? payload.toLowerCase() : payload
      state.language = normalizedLanguage
      if (normalizedLanguage) {
        i18next.changeLanguage(normalizedLanguage)
      }
    },
    setNotification: (state, { payload }) => {
      state.notification = payload
    },
    setCenteredNotification: (state, { payload }) => {
      state.centeredNotification = payload
    },
    setGeneratingShareLink: (state, { payload }) => {
      state.generatingShareLink = payload;
    },
    setShareLink: (state, { payload }) => {
      state.generatingShareLink = false;
      state.shareableLinkId = payload;
    },
    setlogginModal: (state, { payload }) => {
      state.showLoginModal = payload;
    },
    setIsTokenRefreshing: (state, { payload }) => {
      state.isTokenRefreshing = payload;
    },
    setChangeLogs: (state, { payload }) => {
      state.changeLogs = payload;
    },
    setchangeLogConfigs: (state, { payload }) => {
      state.changeLogConfigs = {...state.changeLogConfigs, ...payload};
    },
    setLastURL: (state, { payload }) => {
      state.lastURL = payload;
    },
    toggleShowNews: (state, { payload }) => {
      state.showNews = payload;
    }
  },
})

export const { logout, setUserInfo, setUserToken, setBimCollabToken, setUserConfigs, setActiveProject, setActiveCustomer,
  initClearanceInspectorConfig, setClearanceInspectorConfig,
  initviewerConfig, setviewerConfig, setErrors, setProjects, setEpsgs, setRoles,setPermissions,
  setProcessTypes,setSensorTypes, setProcessStatuses, setCusomers, setLoadingProjects, setLanguage, setNotification, setCenteredNotification,
  setLoading, resetActiveProject, setGeneratingShareLink, setShareLink, setlogginModal,setIsTokenRefreshing,
  setChangeLogs, setchangeLogConfigs,setLastURL,setTrackLayerTypes, setExternalGeoServices, setProjectExternalGeoServices, 
  setExternalGeoServiceTypes, setActiveCustomerRoles, toggleShowNews } = appSlice.actions

export default appSlice.reducer